// extracted by mini-css-extract-plugin
module.exports = {"outerwrapper":"ImageWrapperAlt_outerwrapper__xP-jJ","wrapper":"ImageWrapperAlt_wrapper__P5iOS"};